import { ISubscriptionAsideTotalsItem } from "web/types/Subscription";

export type ProcessedPointBank = {
  pointsBankId: ISubscriptionAsideTotalsItem["pointsBankId"];
  pointsBankPrice: ISubscriptionAsideTotalsItem["points"];
};

type SetAllPointsBankFn = (
  items: ISubscriptionAsideTotalsItem[]
) => ProcessedPointBank[];

const setAllPointsBank: SetAllPointsBankFn = (items) => {
  if (!items?.length) return [];
  const pointBanks = items.filter((item) => item.pointsBank);
  return pointBanks.map(({ pointsBankId, points }) => ({
    pointsBankId,
    pointsBankPrice: points,
  }));
};

export default setAllPointsBank;
